"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopicClusters = getTopicClusters;
exports.getTopicClustersRequestState = getTopicClustersRequestState;

function getTopicClusters(state) {
  return state.topicClusters;
}

function getTopicClustersRequestState(state) {
  return state.topicClustersRequestState;
}